import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import PaywallLayout from '../PaywallLayout';
import Button from '../../../../../Button';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import Points from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../../../../utils/normalizePremiumFolderData';
import { getDeviationResourceType, isVideoDeviation, } from '../../../../_helpers';
import paywallStyles from '../Paywall.scss';
var PremiumFolderPaywall = function (_a) {
    var _b;
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), folderId = _c.folderId, folderUrl = _c.folderUrl, pointPrice = _c.pointPrice, formattedDollarPrice = _c.formattedDollarPrice, subproductId = _c.subproductId;
    var isVideo = isVideoDeviation(deviation);
    return (React.createElement(PaywallLayout, { deviation: deviation, icon: React.createElement("div", { className: paywallStyles['premium-folders-icon'] }), title: t('deviationview.paywall.artstage.premiumFolder.title'), text: isVideo ? (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "deviationview.paywall.artstage.premiumFolder.text.video" },
            "To watch, unlock its",
            React.createElement(BiLink, { className: paywallStyles['folder-preview-button'], href: folderUrl }, "Premium Folder"),
            "and support the artist!")) : (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "deviationview.paywall.artstage.premiumFolder.text" },
            "To view, unlock its",
            React.createElement(BiLink, { className: paywallStyles['folder-preview-button'], href: folderUrl }, "Premium Folder"),
            "and support the artist!")), button: React.createElement(Button, { view: "b18", height: "medium", fullWidth: false, href: subproductId ? Url.checkoutLink(subproductId) : undefined, biData: BiData({
                evid: 361,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                authorid: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid,
                galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
                points: pointPrice,
                rank: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                widgetname: BiContextProvidedValue,
            }) }, "Unlock for ".concat(formattedDollarPrice, " / "),
            React.createElement(Points, { className: paywallStyles['points-icon'], size: IconSize.TINY, disableDefaultColors: true }), "".concat(pointPrice)), width: width, height: height }));
};
PremiumFolderPaywall.displayName = 'PremiumFolderPaywall';
export default PremiumFolderPaywall;
//# sourceMappingURL=PremiumFolderPaywall.js.map